import React from "react";
import { CustomTag } from ".";
import dayjs from "dayjs";

const CustomOption = ({ innerProps, isDisabled, label, isFocused, className, ...props }) => {
    const containerClass = `c-badge-container${className ? ` ${className}` : ''}`;
    
    const getStatusVariant = (engineType) => {
        if (engineType === "dedge") return "purple";
        if (engineType === "reservit") return "warning";
        if (engineType === "mews") return "blue";
        if (engineType === "mister_booking") return "success";
        if (engineType === "amenitiz") return "info";
        if (engineType === "brit_hotels") return "success";
        if (engineType === "namastay") return "purple";
        if (engineType === "synxis") return "warning";
        if (engineType === "cloudbeds") return "blue";
        if (engineType === "thais") return "yellow";
        if (engineType === "siteminder") return "purple";
        if (engineType === "best_western") return "info";
        if (engineType === "the_originals") return "yellow";
        if (engineType === "other") return "default";
        // Défaut bleu : les options non-engine (projets, etc.) étaient bleues
        // avant la migration des types de moteurs.
        return "blue";
    };

    const getOptionClass = (value) => {
        return getStatusVariant(value);
    };
    
    return !isDisabled ? (
        props.data.isInvoice ? (
            <div {...innerProps} className={containerClass}>
                <div className={props.data.exactMatch ? "invoice-option-select exact-match" : "invoice-option-select"}>
                    <div className="invoice-option-select-infos">
                        <div>
                            <span className="invoice-number">{label}</span>
                            <small className="invoice-date">{dayjs(props.data.data.date).format("DD/MM/YYYY")}</small>
                        </div>
                        <div>
                            <small>
                                Total :{" "}
                                <span className="invoice-total">
                                    {Number(props.data.data.total).toLocaleString("fr-FR", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                                </span>
                            </small>
                            <small>
                                Balance :{" "}
                                <span className="invoice-balance">
                                    {Number(props.data.data.balance).toLocaleString("fr-FR", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                                </span>
                            </small>
                        </div>
                    </div>
                    <span className="invoice-customer">
                        {props.data.data.customer_name ? props.data.data.customer_name : props.data.data.vendor_name}
                    </span>
                </div>
            </div>
        ) : props.data.id === "failed" ? (
            <div {...innerProps} className={containerClass}>
                <div className="invoice-option-select failed">
                    <div className="invoice-option-select-infos">
                        <span className="invoice-number">{label}</span>
                    </div>
                    <span className="invoice-customer">
                        Une nouvelle soumission a été demandée, ce paiement sera marqué comme un débit jusqu'à réception du nouveau paiement.
                    </span>
                </div>
            </div>
        ) : (
            <div {...innerProps} className={containerClass}>
                <CustomTag value={label} className={getOptionClass(props.data.value)} />
            </div>
        )
    ) : null;
};

export default CustomOption;
